import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("agm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      localStorage.removeItem("agm_token");
      localStorage.removeItem("agm_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function selectIfZero(e) {
  if (Number(e.target.value) === 0) e.target.select();
}

// Every query that a sale (new sale, edit, or return) can change. Any of those
// mutations should invalidate all of these so the whole app updates at once —
// inventory, receivables, cash, profit, dashboard and reports. Keys are matched
// by prefix, so partial keys like ["pnl-series"] cover their parameterised forms.
export const SALE_AFFECTED_KEYS = [
  "sales", "products", "clients", "client", "outstanding",
  "dashboard", "financial-position", "pnl-series",
  "report-sales", "report-pnl", "report-stock", "report-cash",
  "movements", "notifications", "suppliers", "payables",
];

export function invalidateSaleQueries(qc) {
  SALE_AFFECTED_KEYS.forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
}

export function fmt(n) {
  if (n == null) return "0";
  return new Intl.NumberFormat("en-PK", { maximumFractionDigits: 0 }).format(n);
}
export function fmtMoney(n) {
  return "Rs " + fmt(n);
}
